import { ECRI_ACTIONS } from '../constants';
import { calculateStats } from '../utils/helper';

const getStoreOptions = (data) => {
  const storeNames = [...new Set(data.map((item) => item.name))];
  return [
    { key: 'All Stores', value: 'All Stores', text: 'All Stores' },
    ...storeNames.map((name) => ({ key: name, value: name, text: name })),
  ];
};

const initialState = {
  numberOfItems: undefined,
  allItems: undefined,
  lastUpdated: undefined,
  expandedUnitDetails: [],
  isLoading: false,
  data: undefined,
  originalData: undefined,
  stats: undefined,
  searchTerm: undefined,
  selectedStore: 'All Stores',
  selectedUnitSize: 'All Sizes',
  isEditModeOpen: false,
  editModeData: undefined,
  regionOptions: [],
  selectedRegion: 'All Regions',
  unitSizeOptions: [
    { key: 'All Sizes', value: 'All Sizes', text: 'All Sizes' },
    { key: '5-10', value: '5-10', text: '5-10' },
    { key: '10-20', value: '10-20', text: '10-20' },
  ],
  storeOptions: [
    { key: 'All Stores', value: 'All Stores', text: 'All Stores' },
  ],
  selectedStatus: 'pending',
  statusOptions: ['pending', 'approved', 'excluded'],
  searchPhrase: undefined,
};

const ecriReducer = (state = initialState, action) => {
  switch (action.type) {
    case ECRI_ACTIONS.FETCH_DATA: {
      return {
        ...state,
        data: action.payload.data,
        originalData: action.payload.data,
        numberOfItems: action.payload.numberOfItems,
        lastUpdated: action.payload.lastUpdated,
        allItems: action.payload.allItems,
        storeOptions: getStoreOptions(action.payload.data),
        stats: calculateStats(action.payload.data),
      };
    }

    case ECRI_ACTIONS.SET_REGION: {
      return {
        ...state,
        selectedRegion: action.payload,
      };
    }
    case ECRI_ACTIONS.SET_SEARCH_TERM: {
      return {
        ...state,
        searchTerm: action.payload,
      };
    }
    case ECRI_ACTIONS.SET_UNIT_SIZE: {
      return {
        ...state,
        selectedUnitSize: action.payload,
      };
    }
    case ECRI_ACTIONS.SET_STORE: {
      return {
        ...state,
        selectedStore: action.payload,
      };
    }
    case ECRI_ACTIONS.SET_STATUS: {
      return {
        ...state,
        selectedStatus: action.payload,
      };
    }
    case ECRI_ACTIONS.APPROVE_OFFER: {
      return {
        ...state,
        data: state.data.map((location) => {
          let newLocation = { ...location };
          newLocation.units = location.units.map((unit) => {
            if (
              unit.id === action.payload.id &&
              unit.storeId === action.payload.storeId
            ) {
              return { ...unit, status: 'approved' };
            }
            return unit;
          });
          return newLocation;
        }),
      };
    }
    case ECRI_ACTIONS.APPROVE_ALL_OFFERS: {
      return {
        ...state,
        data: (() => {
          let newData = [...state.data];
          newData = newData.map((item) => {
            let newItem = { ...item };
            if (item.id === action.payload.storeId) {
              newItem.units = newItem.units.map((subItem) => {
                if (subItem.status === action.payload.status)
                  subItem.status = 'approved';
                return subItem;
              });
            }
            return newItem;
          });
          return newData;
        })(),
      };
    }
    case ECRI_ACTIONS.PENDING_OFFER: {
      return {
        ...state,
        data: state.data.map((location) => {
          let newLocation = { ...location };
          newLocation.units = location.units.map((unit) => {
            if (
              unit.id === action.payload.id &&
              unit.storeId === action.payload.storeId
            ) {
              return { ...unit, status: 'pending' };
            }
            return unit;
          });
          return newLocation;
        }),
      };
    }
    case ECRI_ACTIONS.PENDING_ALL_OFFERS: {
      return {
        ...state,
        data: (() => {
          let newData = [...state.data];
          newData = newData.map((item) => {
            let newItem = { ...item };
            if (item.id === action.payload.storeId) {
              newItem.units = newItem.units.map((subItem) => {
                if (subItem.status === action.payload.status)
                  subItem.status = 'pending';
                return subItem;
              });
            }
            return newItem;
          });
          return newData;
        })(),
      };
    }
    case ECRI_ACTIONS.EXCLUDE_OFFER: {
      return {
        ...state,
        data: state.data.map((location) => {
          let newLocation = { ...location };
          newLocation.units = location.units.map((unit) => {
            if (
              unit.id === action.payload.id &&
              unit.storeId === action.payload.storeId
            ) {
              return {
                ...unit,
                status: 'excluded',
                reason: action.payload.reasonData.reason,
                customReason: action.payload.reasonData.customReason,
                period: action.payload.period,
              };
            }
            return unit;
          });
          return newLocation;
        }),
      };
    }
    case ECRI_ACTIONS.SAVE_OFFER: {
      return {
        ...state,
        isEditModeOpen: false,
        editModeData: undefined,
        data: state.data.map((item) => {
          if (item.id === action.payload.editModeData.storeId) {
            return {
              ...item,
              units: item.units.map((subItem) => {
                if (subItem.id === action.payload.editModeData.id) {
                  return {
                    ...subItem,
                    finalPrice: action.payload.content.suggestedPrice,
                  };
                }
                return subItem;
              }),
            };
          }
          return item;
        }),
      };
    }
    case ECRI_ACTIONS.OPEN_EDIT_MODE: {
      return {
        ...state,
        isEditModeOpen: true,
        editModeData: {
          id: action.payload.id,
          storeId: action.payload.storeId,
        },
      };
    }
    case ECRI_ACTIONS.CLOSE_EDIT_MODE: {
      return {
        ...state,
        isEditModeOpen: false,
        editModeData: undefined,
      };
    }
    case ECRI_ACTIONS.TOGGLE_UNIT_DETAILS: {
      return {
        ...state,
        expandedUnitDetails: (() => {
          let newExpandedUnitDetails = [];
          if (state.expandedUnitDetails.includes(action.payload)) {
            state.expandedUnitDetails.forEach((item) => {
              if (item !== action.payload) {
                newExpandedUnitDetails.push(item);
              }
            });
          } else {
            newExpandedUnitDetails = [...state.expandedUnitDetails];
            newExpandedUnitDetails.push(action.payload);
          }
          return newExpandedUnitDetails;
        })(),
      };
    }
    case ECRI_ACTIONS.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case ECRI_ACTIONS.FETCH_STATS: {
      return {
        ...state,
        stats: action.payload,
      };
    }

    case ECRI_ACTIONS.SET_REGION_OPTIONS: {
      return {
        ...state,
        regionOptions: action.payload,
      };
    }
    default:
      return state;
  }
};

export default ecriReducer;
